import {ButtonGroup} from '@kit';

import React from 'react';

import {FeatCategory, SourceBook} from '../../../generated/types';
import {enumList, Filters, FiltersPopup} from '../../../components/filters';
import {featCategoryToString, sourceBookToString} from '../../../components/enums';

const CATEGORIES = [
	FeatCategory.Origin,
	FeatCategory.General,
	FeatCategory.FightingStyle,
	FeatCategory.EpicBones,
	FeatCategory.PlanarPact,
];
const SOURCES = [SourceBook.XPHB, SourceBook.XDMG, SourceBook.AU, SourceBook.FRHoF, SourceBook.DDBD];

export const featFilters = {
	categories: enumList('category', CATEGORIES),
	sources: enumList('source', SOURCES),
};

type Props = {
	filters: Filters<typeof featFilters>;
};

export const FeatFilters: React.FC<Props> = ({filters}) => (
	<FiltersPopup filters={filters} header="Фильтровать черты">
		<li>
			<ButtonGroup
				items={CATEGORIES}
				itemToHtml={featCategoryToString}
				multiple
				label="Категория"
				{...filters.field('categories')}
			/>
		</li>
		<li>
			<ButtonGroup
				items={SOURCES}
				itemToHtml={sourceBookToString}
				multiple
				label="Источник"
				{...filters.field('sources')}
			/>
		</li>
	</FiltersPopup>
);
